import { type Router } from 'vue-router'
import { useUserStore } from '@/store/user'

const AI_ROUTE_NAMES = new Set([
  'ai',
  'ai-new',
  'ai-conversation',
  'ai-document',
  'ai-skills',
  'ai-skill-new',
  'ai-skill-edit'
])

export default function useAiAccess(router: Router) {
  router.beforeEach(to => {
    if (typeof to.name !== 'string' || !AI_ROUTE_NAMES.has(to.name)) return
    if (useUserStore().aiEnabled) return
    return { name: 'deck', replace: true }
  })
}
